import { render, staticRenderFns } from "./SupplierGeneral.vue?vue&type=template&id=0469092e&scoped=true&"
import script from "./SupplierGeneral.vue?vue&type=script&lang=js&"
export * from "./SupplierGeneral.vue?vue&type=script&lang=js&"
import style0 from "./SupplierGeneral.vue?vue&type=style&index=0&id=0469092e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0469092e",
  null
  
)

export default component.exports